import { useState, useEffect, useCallback } from "react";
import api from "../utils/api";
import toast from "react-hot-toast";

// Vehicle Profile is a read-only aggregate view, so unlike the tab-level hooks
// (useTrips, useMaintenance, etc.) this fetches all five endpoints pre-filtered
// to one vehicle in parallel, rather than filtering an org-wide list client-side.
export function useVehicleProfile(vehicleId) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!vehicleId) return;
    setLoading(true);
    try {
      const [documents, maintenance, fuelLogs, expenses, trips] = await Promise.all([
        api.get(`/api/vehicle-documents?vehicleId=${vehicleId}`),
        api.get(`/api/maintenance?vehicleId=${vehicleId}`),
        api.get(`/api/fuel-logs?vehicleId=${vehicleId}`),
        api.get(`/api/expenses?vehicleId=${vehicleId}`),
        api.get(`/api/trips?vehicleId=${vehicleId}`),
      ]);
      setData({
        documents: documents.data, maintenance: maintenance.data,
        fuelLogs: fuelLogs.data, expenses: expenses.data, trips: trips.data,
      });
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load vehicle profile");
    } finally {
      setLoading(false);
    }
  }, [vehicleId]);

  useEffect(() => { load(); }, [load]);

  return { data, loading, reload: load };
}
